import { Http } from '../axios/interceptors'

// ---------------------------------- Countries
export const allCountries = async () => Http('GET', '/Countries/GetListCountries')

export const allCities = async idCountry => Http('GET', `/Countries/GetCities?idCountry=${idCountry}`)
